import React, { useEffect } from 'react';

export function AdminGroupOrder() {
  useEffect(() => {}, []);

  // AdminGroupOrder 리턴값
  return (
    <main className="shipping wrapper">
      <div className="title">
        <h1>단체주문 안내 관리</h1>
        <div className="buttons">
          <button type="button">저장</button>
        </div>
      </div>
      <div className="content">
        <h3>단체주문 안내</h3>
        <textarea name="" id="" />
      </div>
    </main>
  );
}

// 미사용 페이지
